import React from 'react'


import { UniversalLandingPage } from 'pages/landing'
import { useLocation, } from 'react-router-dom'
import UniversalPlayground from 'playground/universal-playground'
import UniversalTransient from './transient/universal-transient'
import { NoSsr } from '@material-ui/core'
import { zoomDashboardUrl, zoomInFrameUrl } from 'zoom/places.zoom'
import { UniversalIframeMeeting } from 'zoom-dashboard/UniversalIframeMeeting'
import { UniversalMeetingDashboard } from 'zoom-dashboard/UniversalMeetingDashboard'
import { GPopup } from 'lib-core'



const RootPages = () => {
    const location = useLocation()
    const pathname = location.pathname

    if (pathname.startsWith(zoomDashboardUrl)) {
        return <NoSsr><UniversalMeetingDashboard /></NoSsr>
    }

    if (pathname.startsWith(zoomInFrameUrl)) {
        return <NoSsr><UniversalIframeMeeting /></NoSsr>
    }

    if (pathname.startsWith("/trans")) {
        return <NoSsr><UniversalTransient /></NoSsr>
    }    

    if (pathname.startsWith("/playground")) {
        return <NoSsr><UniversalPlayground /></NoSsr>
    }

    if (pathname.startsWith("/gpopup/")) {
        return <GPopup />
    }
   
    return <UniversalLandingPage />

}


export default RootPages